// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + "a9b25f67ffc4a23b16a7" + ".chunk.js";
};